<template lang='pug'>
  i.svg-icon.svg-icon-rank
    svg(
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100')

      path(fill='#F18D1B' d='M68.973,56.061h-2.455v-9.381h2.455c7.758,0,14.07-6.624,14.07-14.382v-4.69h-14.07v-9.38h23.451v14.07 C92.424,45.226,81.902,56.061,68.973,56.061z')
      path(fill='#F2BA1A' d='M33.907,56.061h-2.455c-12.93,0-23.451-10.835-23.451-23.764v-14.07h23.451v9.38H17.381v4.69 c0,7.758,6.313,14.382,14.071,14.382h2.455V56.061z')
      path(fill='#F5D339' d='M26.762,8.846v33.143c0,3.658,0.844,7.129,2.439,10.318c1.876,3.847,4.879,7.505,7.879,10.975 c4.127,4.973,8.441,10.036,8.441,14.352v11.257h9.381V77.634c0-4.315,4.315-9.379,8.441-14.352c3.002-3.47,6.005-7.128,7.88-10.88 c1.596-3.284,2.439-6.755,2.439-10.413V8.846H26.762z')
      path(fill='#F2BA1A' d='M54.902,88.891h-4.689V8.846h23.45v33.143c0,3.658-0.844,7.129-2.439,10.413 c-1.875,3.752-4.878,7.41-7.88,10.88c-4.126,4.973-8.441,10.036-8.441,14.352V88.891z')
      path(fill='#F2BA1A' d='M29.847,80.992h43.816v11.354H29.847V80.992z')
      path(fill='#F18D1B' d='M51.755,80.992h21.908v11.354H51.755V80.992z')

      path(fill='#E36256' d='M69.662,31.858H49.319v30.599h20.343c3.965,0,7.181-3.281,7.181-7.327V39.187 C76.843,35.139,73.627,31.858,69.662,31.858z')
      path(fill='#11979D' d='M49.319,31.858H28.978c-3.964,0-7.179,3.28-7.179,7.328v15.942c0,4.047,3.215,7.328,7.179,7.328h20.342 V31.858z')
      path(fill='#FFFFFF' d='M33.752,39.398h4.984v5.645h5.446v-5.645h5.007v16.129h-5.007v-6.523h-5.446v6.523h-4.984V39.398z')
      path(fill='#FFFFFF' d='M52.479,39.398h8.283c1.805,0,3.156,0.429,4.055,1.288c0.899,0.858,1.349,2.08,1.349,3.664 c0,1.628-0.49,2.901-1.47,3.818c-0.979,0.917-2.473,1.375-4.482,1.375h-2.73v5.985h-5.004V39.398z M57.483,46.275h1.222 c0.962,0,1.637-0.167,2.026-0.5c0.388-0.334,0.582-0.761,0.582-1.282c0-0.506-0.168-0.936-0.507-1.288 c-0.336-0.352-0.972-0.528-1.902-0.528h-1.421V46.275z')


</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '',
    },
  },
};

</script>
